import React, { useEffect, useState, } from 'react'
import { Button, Popover } from 'antd';
import styles from './style.module.less';

export default function RetailCode(props) {

  useEffect(() => {
    return () => {
    }
  }, [])

  const popoverContent = (
    <div className={styles.qrcodeWrap}>
      <img src="/images/retail-code.jpg" />
      <p style={{ textAlign: 'center' }}>小兵速帮散户端小程序</p>
      <p>保外工单由散户自己创建，可将小兵速帮微信小程序二维码图片或链接发送给用户，由用户自己创建工单（客户承担费用）。</p>
    </div>
  );

  return (
    <>
      <Popover trigger="click" placement="bottom" content={popoverContent}>
        <Button
          type="primary"
          style={{ marginLeft: '10px' }}
        >
          保外工单
        </Button>
      </Popover>
    </>
  );
}
